import { defineStore } from "pinia";

export const useModalStore = defineStore("modal", {
  state: () => ({
    isPhoneModalOpen: false, // единственный флаг
    isOpenCabinet: false,
    isRulesModalOpen: false,
    isMessageModalOpen: false,
    isRegisterModalOpen: false,
    isLoginModalOpen: false,
    isAuthModalOpen: false,
    isResetPasswordModalOpen: false,
  }),
  actions: {
    openPhoneModal() {
      this.closeAllModals();
      this.isPhoneModalOpen = true;
    },
    closePhoneModal() {
      this.isPhoneModalOpen = false;
    },
    openMessageModal() {
      this.closeAllModals();
      this.isMessageModalOpen = true;
    },
    closeMessageModal() {
      this.isMessageModalOpen = false;
    },
    openRulesModal() {
      this.closeAllModals();
      this.isRulesModalOpen = true;
    },
    closeRulesModal() {
      this.isRulesModalOpen = false;
    },
    openCabinet() {
      this.closeAllModals();
      this.isOpenCabinet = true;
    },
    closeCabinet() {
      this.isOpenCabinet = false;
    },
    openRegisterModal() {
      this.closeAllModals();
      this.isRegisterModalOpen = true;
    },
    closeRegisterModal() {
      this.isRegisterModalOpen = false;
    },

    openLoginModal() {
      this.closeAllModals();
      this.isLoginModalOpen = true;
    },
    closeLoginModal() {
      this.isLoginModalOpen = false;
    },

    openAuthModal() {
      this.closeAllModals();
      this.isAuthModalOpen = true;
    },
    closeAuthModal() {
      this.isAuthModalOpen = false;
    },

    openResetPasswordModal() {
      this.closeAllModals();
      this.isResetPasswordModalOpen = true;
    },
    closeResetPasswordModal() {
      this.isResetPasswordModalOpen = false;
    },
    closeAllModals() {
      this.isPhoneModalOpen = false;
      this.isRegisterModalOpen = false;
      this.isLoginModalOpen = false;
      this.isAuthModalOpen = false;
      this.isResetPasswordModalOpen = false;
      this.isRulesModalOpen = false;
      this.isMessageModalOpen = false;
    },
  },
});
